<script>
import { mapGetters, mapState } from "vuex";

import professionalMixin from "@/mixins/accountable/professionalMixin";
import dateMixin from "@/mixins/dateMixin";

import Modal from "@/components/_Shared/Modal/Index";
import Tip from "@/components/_base/Tip";
import Star from "@/components/_base/Star";

import ScheduleEvents from "../ProfessionalFilters/ScheduleEvents";
import HourPicker from "../ProfessionalFilters/HourPicker";
import DurationPicker from "../ProfessionalFilters/DurationPicker";

export default {
  mixins: [professionalMixin, dateMixin],

  components: {
    Modal,
    Tip,
    ScheduleEvents,
    HourPicker,
    DurationPicker,
    Star
  },

  data() {
    return {
      filter: "date",
      FiltersChanged: false
    };
  },

  methods: {
    toogleFilter(filter) {
      this.filter = filter;
    },

    isSelected(filter) {
      return this.filter === filter;
    },

    day() {
      return this.$options.filters.formatDate(this.date, "DD/MM");
    },

    time() {
      return (this.initialHour < 10 ? "0" : "") + `${this.initialHour}h`;
    },

    hours() {
      return `${this.duration} hora` + (this.duration > 1 ? "s" : "");
    },

    totalOrders() {
      return this.$options.filters.orderCount(this.professional);
    }
  },

  computed: {
    ...mapGetters("orderScheduler", [
      "missingRequiredFields",
      "date",
      "initialHour",
      "duration",
      "professional"
    ]),
    ...mapState("orderScheduler", ["professionalDirectSearch"]),

    professionalName: function() {
      return this.$options.filters.firstName(this.professional);
    }
  },

  watch: {
    date(newValue, oldValue) {
      if (newValue != oldValue) {
        this.FiltersChanged = true;
      }
    },

    initialHour(newValue, oldValue) {
      if (newValue != oldValue) {
        this.FiltersChanged = true;
      }
    },

    duration(newValue, oldValue) {
      if (newValue != oldValue) {
        this.FiltersChanged = true;
      }
    }
  }
};
</script>

<template>
  <Modal>
    <template slot="header">
      <div class="profile" >
        <img class="profile-picture" :src="professional | profilePicture" />

        <div class="profile-info">
          <div class="name">
            Agenda de {{ professionalName }}

            <div class="rating">
              <Star />

              <span class="rating-number">
                {{ professional | rating }} <span class="feedback-count" v-if="professional.total_feedbacks_count > 3">({{ professional | feedbacks }})</span>
              </span>
            </div>
          </div>

          <div class="orders-count">
            {{ totalOrders() > 0 ? `${totalOrders()} limpezas  realizadas` : 'Novo(a) profissional' }}
          </div>
        </div>
      </div>

      <div class="dtd">
        <div class="date" @click="toogleFilter('date')" :class="{ selected: isSelected('date')}">
          <img src="/static/calendar-outlined.svg" />
          <span>{{ !date ? "Dia" : day() }}</span>
        </div>

        <div class="time" @click="toogleFilter('time')" :class="{ selected: isSelected('time')}">
          <img src="/static/clock-outlined.svg" />
          {{ !initialHour ? "Hora inicial" : time() }}
        </div>

        <div class="duration" @click="toogleFilter('duration')" :class="{ selected: isSelected('duration')}">
          <img src="/static/stopwatch-outlined.svg" />
          {{ !duration ? "Duração" : hours() }}
        </div>
      </div>

      <Tip type="alert" size="small" v-if="!date || !initialHour || !duration" class="tip-alert">
        É necessário selecionar o dia, hora inicial e duração para continuar com o agendamento.
      </Tip>
    </template>

    <template slot="body">
      <div class="picker">
        <ScheduleEvents v-if="filter === 'date'" @dateSelected="toogleFilter('time')" />

        <HourPicker v-if="filter === 'time'" @hourSelected="toogleFilter('duration')" />

        <DurationPicker v-if="filter === 'duration'" />
      </div>
    </template>

    <template slot="footer">
      <Tip v-if="filter === 'date'">Selecione ou altere o dia que você gostaria de realizar a limpeza.</Tip>

      <Tip v-if="filter === 'time'">Selecione ou altere a hora de inicio da limpeza.</Tip>

      <Tip v-if="filter === 'duration'">Selecione ou altere a duração da limpeza.</Tip>

      <button
        class="btn bg-purple"
        :class="{ 'btn-disabled': missingRequiredFields }" :disabled="missingRequiredFields"
        @click="$emit('scheduleConfirmation')"
      >
        <span>Confirmar dia, hora e duração</span>
      </button>

      <button class="btn bg-outlined" @click="$emit('returnToSearch', FiltersChanged)">
        <span>{{ professionalDirectSearch ? "Voltar" : "Voltar para a pesquisa" }}</span>
      </button>
    </template>
  </Modal>
</template>

<style scoped>
.dtd {
  width: calc(100% - 4px);
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #e2e2e2;
  border-radius: 2px;
  padding: 2px;
  margin-bottom: 8px;
}

.date,
.duration,
.time {
  padding: 8px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-size: 14px;
  color: #424242;
  text-align: center;
  background: #fff;
  font-weight: 400;
  border: solid 2px #e2e2e2;
  transition: border-color 250ms ease-in-out;
  cursor: pointer;
}

.date,
.duration {
  width: 30%;
}

.time {
  width: 40%;
}

.selected {
  border: solid 2px #603285;
}

img {
  height: 16px;
  width: 16px;
  margin-right: 4px;
}

.picker {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: solid 1px #e2e2e2;
}

.profile-picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.profile-info {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}

.name {
  display: flex;
  color: #424242;
  font-size: 15px;
  font-weight: 400;
}

.rating {
  display: flex;
  align-items: center;
}

.rating > .rating-number {
  font-weight: 300;
  font-size: 14px;
  font-weight: 400;
  margin-left: 4px;
  padding-left: 4px;
  display: flex;
  align-items: center;
  border-left: solid 1px #ddd;
}

.orders-count {
  font-size: 13px;
}

.orders-count > span {
  font-weight: 400;
  color: #603285;
}

.bg-outlined {
  padding: 8px 16px;
}
.feedback-count {
  margin-left: 4px;
}

@media (max-width: 374px) {
  .tip-alert {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Professional/Schedule.vue